<template>
  <div class="loading-spinner">
    <img :src="src" :alt="alt" :class="imgClass" />
  </div>
</template>

<script setup lang="ts">
import loadingSvg from '@/assets/images/loading.svg';
import '@/assets/stylesheets/components/_loading_spinner.scss';

defineProps({
  src: { type: String, default: loadingSvg },
  alt: { type: String, default: 'Loading...' },
  width: { type: String, default: '40px' },
  height: { type: String, default: '50vh' },
  imgClass: { type: String, default: '' },
});
</script>
